import BaseService from './base.service'
import moment from 'moment';

class PlaybooksService extends BaseService {
  get entity () {
    return 'playbook'
  }

  updatePlaybook(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).put(`users/current/projects/${entity.project_id}/playbooks/${entity.playbook_id}`, {
        project_id: entity.project_id,
        playbook_id: entity.playbook_id,
        goal: entity.goal,
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  setDistribution(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).put(`users/current/projects/${entity.project_id}/bots/${entity.bot_id}/set-distributions`, entity)
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  createPlaybook(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post(`users/current/projects/${entity.project_id}/playbooks`, {
        project_id: entity.project_id,
        bot_id: entity.bot_id,
        time_of_days: entity.time_of_days,
        goal: entity.goal,
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  deletePlaybook(entity) {
    return new Promise((resolve, reject) => {
        return this.request({ auth: true }).delete(`users/current/projects/${entity.project_id}/playbooks/${entity.playbook_id}`, {
          project_id: entity.project_id,
          playbook_id: entity.bot_id
        })
          .then(response => resolve(this.responseWrapper(response, response.data)))
          .catch(error => reject(this.errorWrapper(error)))
      })
  }

  getAdvancedSettings(entity) {
    return new Promise((resolved, rejected) => {
      return this.request({ auth: true }).get(`users/current/projects/${entity.project_id}/bots/${entity.bot_id}/settings`)
          .then(response => resolved(this.responseWrapper(response, response.data)))
          .catch(error => {
            let message = error.response.data ? error.response.data.error : error.response.statusText
            rejected(this.errorWrapper(error, message))
          })
    })
  }

  setAdvancedSettings(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).put(`users/current/projects/${entity.project_id}/playbooks/${entity.playbook_id}/settings`, entity)
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }
  
  deleteAdvancedSettings(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).delete(`users/current/projects/${entity.project_id}/bots/${entity.bot_id}/settings`, entity)
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }
}

export default new PlaybooksService()
